import mitt from 'mitt'
// const widgetEvent = mitt()
export const emitter = mitt()
// export default widgetEvent
